import { Component } from 'react';
import { connect } from 'react-redux';
import { ILocalization } from '../../../localization/definitions/types';
import { RootState } from '../../../store';
import './NewReleaseModal.css';
import Logo from '../../../../src/img/svg/newReleaseModalLogo.svg';
import { IChangeLog } from '../../../definitions/interfaces/IChangelog';
import { DateFormat, formatDate } from 'susy-common/date-utils';
import ChangelogItemBody from '../../help/changelog/ChangelogItemBody';
import { SusyModal } from '../modals/susyModal/SusyModal';
import SusyButton from '../buttons/SusyButton';

interface IProps {
    localization: ILocalization;
    showModal: boolean;
    onHide: () => void;
    onReadFullChangelog: () => void;
    changelog: IChangeLog;
}

class NewReleaseModal extends Component<IProps> {
    render() {
        const localization =
            this.props.localization.localizationStrings.susy.shared
                .newReleaseModal;
        const modalBody = (
            <>
                <div className={'rectangle d-flex ml-auto mr-auto'}>
                    <img
                        className={'ml-auto mr-auto logo'}
                        src={Logo}
                        alt='icon'
                    />
                </div>
                <div className={'update-rectangle d-flex ml-auto mr-auto'}>
                    <div className={'update-headline'}>
                        {localization.update}
                        <b>v{this.props.changelog?.versionNumber}</b>
                        <div className={'update-headline-date'}>
                            {localization.date}{' '}
                            {formatDate(
                                this.props.changelog.releaseDate,
                                DateFormat.DOT_DD_MM_YYYY
                            )}
                        </div>
                    </div>
                    <div className={'p-3'}>
                        <ChangelogItemBody changeLog={this.props.changelog} />
                    </div>
                </div>
                <SusyButton
                    text={localization.readFullChangelog}
                    onClickHandler={this.props.onReadFullChangelog}
                    kind='secondary'
                    classes='mt-4 ml-auto mr-auto'
                />
            </>
        );
        return (
            <SusyModal
                showModal={this.props.showModal}
                onHide={this.props.onHide}
                title={localization.headline}
                modalBody={modalBody}
            />
        );
    }
}

const mapStateToProps = (state: RootState) => {
    return {
        localization: state.localization,
    };
};

export default connect(mapStateToProps)(NewReleaseModal);
